export default function ArrowRight() {
    return (
        <svg>
            <use xlinkHref="#arrow-right" />
        </svg>
    );
}
